/**
 * Frases de evolução da participação — narrativa calma e positiva. Nunca punitiva:
 * queda vira "tem oscilado", poucos dados vira "primeiras explorações".
 */
import { MIN_MOMENTOS_TENDENCIA } from "./domain";
import { PARTICIPACAO_LABEL, type DerivadosAtividade, type MomentoPsicomotor } from "./types";

export function fraseParticipacao(
  nome: string,
  momentos: MomentoPsicomotor[],
  d: DerivadosAtividade,
): string {
  if (d.n_momentos === 0) {
    return "ainda sem momentos — quando começar, a evolução aparece aqui.";
  }

  const confirmados = momentos
    .filter((m) => m.confirmado)
    .sort((a, b) => a.data_hora.localeCompare(b.data_hora));
  const primeiro = confirmados[0]?.passo_participacao ?? d.passo_atual;

  if (d.n_momentos < MIN_MOMENTOS_TENDENCIA) {
    return `primeiras explorações de ${nome}. cada momento conta 🤸`;
  }

  if (d.passo_maximo !== null && primeiro !== null && d.passo_maximo > primeiro) {
    return `saiu de "${PARTICIPACAO_LABEL[primeiro]}" e já chegou a "${PARTICIPACAO_LABEL[d.passo_maximo]}" 🎉`;
  }

  if (d.autonomia === "cresce") return "está precisando de menos ajuda a cada vez — autonomia crescendo 🌱";
  if (d.tendencia === "subindo") return "está participando mais a cada vez — continue 🤸";
  if (d.tendencia === "caindo") return "tem oscilado um pouco — sem pressão, faz parte do caminho.";
  if (d.passo_atual !== null) {
    return `mantendo "${PARTICIPACAO_LABEL[d.passo_atual]}" com consistência.`;
  }
  return "seguindo o ritmo.";
}
